import { render, staticRenderFns } from "./purchasePlanAction.vue?vue&type=template&id=6d8e4e96&scoped=true"
import script from "./purchasePlanAction.vue?vue&type=script&lang=js"
export * from "./purchasePlanAction.vue?vue&type=script&lang=js"
import style0 from "./purchasePlanAction.vue?vue&type=style&index=0&id=6d8e4e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e4e96",
  null
  
)

export default component.exports